var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisiblityoffIconSvgModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2165 15.7832L15.7832 24.2165C14.6999 23.1332 14.0332 21.6498 14.0332 19.9998C14.0332 16.6998 16.6998 14.0332 19.9998 14.0332C21.6498 14.0332 23.1332 14.6999 24.2165 15.7832Z",
    stroke: "#B76E79",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6997 9.61667C26.783 7.41667 23.4497 6.21667 19.9997 6.21667C14.1164 6.21667 8.63307 9.68334 4.81641 15.6833C3.31641 18.0334 3.31641 21.9834 4.81641 24.3334C6.13307 26.4 7.66641 28.1834 9.33307 29.6167",
    stroke: "#B76E79",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0332 32.5498C15.9332 33.3498 17.9498 33.7832 19.9998 33.7832C25.8832 33.7832 31.3665 30.3165 35.1832 24.3165C36.6832 21.9665 36.6832 18.0165 35.1832 15.6666C34.6332 14.7999 34.0332 13.9832 33.4165 13.2166",
    stroke: "#B76E79",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8499 21.1666C25.4166 23.5166 23.4999 25.4333 21.1499 25.8666",
    stroke: "#B76E79",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7835 24.2167L3.3335 36.6667",
    stroke: "#B76E79",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 3.33337L24.2163 15.7834",
    stroke: "#B76E79",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisiblityoffIconSvgModel);
export default __webpack_public_path__ + "static/media/visiblityoffIconSVGModel.4e847de70dde4759ec09ef3ad2aadbfc.svg";
export { ForwardRef as ReactComponent };